{
  "department": {
    "OTHER": "Other",
    "AIN": "Ain",
    "AISNE": "Aisne",
    "ALLIER": "Allier",
    "ALPES_DE_HAUTE_PROVENCE": "Alpes-de-Haute-Provence",
    "HAUTES_ALPES": "Hautes-alpes",
    "ALPES_MARITIMES": "Alpes-maritimes",
    "ARDECHE": "Ardèche",
    "ARDENNES": "Ardennes",
    "ARIEGE": "Ariège",
    "AUBE": "Aube",
    "AUDE": "Aude",
    "AVEYRON": "Aveyron",
    "BOUCHES_DU_RHONE": "Bouches-du-Rhône",
    "CALVADOS": "Calvados",
    "CANTAL": "Cantal",
    "CHARENTE": "Charente",
    "CHARENTE_MARITIME": "Charente-maritime",
    "CHER": "Cher",
    "CORREZE": "Corrèze",
    "CORSE_DU_SUD": "Corse-du-sud",
    "HAUTE_CORSE": "Haute-Corse",
    "COTE_D_OR": "Côte-d'Or",
    "COTES_D_ARMOR": "Côtes-d'Armor",
    "CREUSE": "Creuse",
    "DORDOGNE": "Dordogne",
    "DOUBS": "Doubs",
    "DROME": "Drôme",
    "EURE": "Eure",
    "EURE_ET_LOIR": "Eure-et-loir",
    "FINISTERE": "Finistère",
    "GARD": "Gard",
    "HAUTE_GARONNE": "Haute-garonne",
    "GERS": "Gers",
    "GIRONDE": "Gironde",
    "HERAULT": "Hérault",
    "ILLE_ET_VILAINE": "Ille-et-vilaine",
    "INDRE": "Indre",
    "INDRE_ET_LOIRE": "Indre-et-loire",
    "ISERE": "Isère",
    "JURA": "Jura",
    "LANDES": "Landes",
    "LOIR_ET_CHER": "Loir-et-cher",
    "LOIR": "Loir",
    "HAUTE_LOIRE": "Haute-loire",
    "LOIRE_ATLANTIQUE": "Loire-atlantique",
    "LOIRET": "Loiret",
    "LOT": "Lot",
    "LOT_ET_GARONNE": "Lot-et-garonne",
    "LOZERE": "Lozère",
    "MAINE_ET_LOIRE": "Maine-et-loire",
    "MANCHE": "Manche",
    "MARNE": "Marne",
    "HAUTE_MARNE": "Haute-marne",
    "MAYENNE": "Mayenne",
    "MEURTHE_ET_MOSELLE": "Meurthe-et-moselle",
    "MEUSE": "Meuse",
    "MORBIHAN": "Morbihan",
    "MOSELLE": "Moselle",
    "NIEVRE": "Nièvre",
    "NORD": "Nord",
    "OISE": "Oise",
    "ORNE": "Orne",
    "PAS_DE_CALAIS": "Pas-de-calais",
    "PUY_DE_DOME": "Puy-de-dôme",
    "PYRENEES_ATLANTIQUES": "Pyrénées-atlantiques",
    "HAUTES_PYRENEES": "Hautes-Pyrénées",
    "PYRENEES_ORIENTALES": "Pyrénées-orientales",
    "BAS_RHIN": "Bas-rhin",
    "HAUT_RHIN": "Haut-rhin",
    "RHONE": "Rhône",
    "HAUTE_SAONE": "Haute-saône",
    "SAONE_ET_LOIRE": "Saône-et-loire",
    "SARTHE": "Sarthe",
    "SAVOIE": "Savoie",
    "HAUTE_SAVOIE": "Haute-savoie",
    "PARIS": "Paris",
    "SEINE_MARITIME": "Seine-maritime",
    "SEINE_ET_MARNE": "Seine-et-marne",
    "YVELINES": "Yvelines",
    "DEUX_SEVRES": "Deux-sèvres",
    "SOMME": "Somme",
    "TARN": "Tarn",
    "TARN_ET_GARONNE": "Tarn-et-Garonne",
    "VAR": "Var",
    "VAUCLUSE": "Vaucluse",
    "VENDEE": "Vendée",
    "VIENNE": "Vienne",
    "HAUTE_VIENNE": "Haute-vienne",
    "VOSGES": "Vosges",
    "YONNE": "Yonne",
    "TERRITOIRE_DE_BELFORT": "Territoire de belfort",
    "ESSONNE": "Essonne",
    "HAUTS_DE_SEINE": "Hauts-de-seine",
    "SEINE_SAINT_DENIS": "Seine-Saint-Denis",
    "VAL_DE_MARNE": "Val-de-marne",
    "VAL_D_OISE": "Val-d'Oise",
    "GUADELOUPE": "Guadeloupe",
    "MARTINIQUE": "Martinique",
    "GUYANE": "Guyane",
    "LA_REUNION": "La réunion",
    "MAYOTTE": "Mayotte"
  },
  "country": {
    "OTHER": "Other",
    "FRANCE": "France"
  }
}
